import { Component } from '@angular/core';
import { AnalyticsComponent } from '../dashboard/analytics/analytics.component';

@Component({
  selector: 'app-statistics',
  templateUrl: './statistics.page.html',
  standalone: true,
  imports: [AnalyticsComponent],
})
export class StatisticsPage {}
